import(/* webpackChunkName: "pagination" */ '../../Pagination/Styles/pagination.scss');

await import(/* webpackChunkName: "slicksliderselfinit" */ 'Common/Frontend/components/molecules/slickslider/slicksliderselfinit.cmp');

window.am = window.am || {};

window.am.pagination = new function () {
    var that = this;
    var selectOnChangeEvent = function () {
        window.location = window.location.pathname + this.value;
    };

    that.init = function () {
        that.initSelectPagination();
        that.initDotPagination();
    };

    that.initSelectPagination = function () {
        var selects = document.querySelectorAll('.pagination-select');

        for (var iForSelects = 0; iForSelects < selects.length; iForSelects++) {
            selects[iForSelects].addEventListener('change', selectOnChangeEvent);
        }
    };

    that.initDotPagination = function () {
        document.querySelectorAll(".pagination.pagination-dots").forEach(function (pagination) {
            var prevButton = pagination.querySelector('.pagination-prev');
            var nextButton = pagination.querySelector('.pagination-next');
            var slickActiveSliderButton = pagination.querySelector('.slick-active button');

            if (!slickActiveSliderButton) {
                return;
            }

            slickActiveSliderButton.setAttribute('tabindex', '-1');

            prevButton.addEventListener('keydown', function (e) {
                if (e.keyCode == 13) {
                    prevButton.click();
                }
            });

            prevButton.addEventListener('keyup', function (e) {
                if (e.keyCode == 13) {
                    slickActiveSliderButton = pagination.querySelector('.slick-active button');
                    slickActiveSliderButton.setAttribute('tabindex', '-1');
                }
            });

            nextButton.addEventListener('keydown', function (e) {
                if (e.keyCode == 13) {
                    nextButton.click();
                }
            });

            nextButton.addEventListener('keyup', function (e) {
                if (e.keyCode == 13) {
                    slickActiveSliderButton = pagination.querySelector('.slick-active button');
                    slickActiveSliderButton.setAttribute('tabindex', '-1');
                }
            });

            var dotsNavContainer = pagination.querySelector('.dots-nav-container');
            var ulTitleAttribute = dotsNavContainer == null ? null : dotsNavContainer.getAttribute('data-ul-title');
            var slickDotsUl = pagination.querySelector('.slider-nav-container ul.pagination-dots');

            if (slickDotsUl != null) {
                slickDotsUl.removeAttribute('role');
                slickDotsUl.setAttribute('role', 'slider');

                if (ulTitleAttribute != null) {
                    slickDotsUl.setAttribute('title', ulTitleAttribute);
                }
            }
        });
    };
};

window.am.pagination.init();